// GET PLACE CONTACTS
export const GET_PLACE_CONTACTS = 'GET_PLACE_CONTACTS';
export const GET_PLACE_CONTACTS_SUCCESS = 'GET_PLACE_CONTACTS_SUCCESS';
export const GET_PLACE_CONTACTS_FAILED = 'GET_PLACE_CONTACTS_FAILED';

// GET PLACE CONTACT DETAILS
export const GET_PLACE_CONTACT_DETAILS = 'GET_PLACE_CONTACT_DETAILS';
export const GET_PLACE_CONTACT_DETAILS_SUCCESS = 'GET_PLACE_CONTACT_DETAILS_SUCCESS';
export const GET_PLACE_CONTACT_DETAILS_FAILED = 'GET_PLACE_CONTACT_DETAILS_FAILED';

// ADD PLACE CONTACT
export const ADD_PLACE_CONTACT = 'ADD_PLACE_CONTACT';
export const ADD_PLACE_CONTACT_SUCCESS = 'ADD_PLACE_CONTACT_SUCCESS';
export const ADD_PLACE_CONTACT_FAILED = 'ADD_PLACE_CONTACT_FAILED';

// EDIT PLACE CONTACT
export const EDIT_PLACE_CONTACT = 'EDIT_PLACE_CONTACT';
export const EDIT_PLACE_CONTACT_SUCCESS = 'EDIT_PLACE_CONTACT_SUCCESS';
export const EDIT_PLACE_CONTACT_FAILED = 'EDIT_PLACE_CONTACT_FAILED';

// DELETE PLACE CONTACT
export const DELETE_PLACE_CONTACT = 'DELETE_PLACE_CONTACT';
export const DELETE_PLACE_CONTACT_SUCCESS = 'DELETE_PLACE_CONTACT_SUCCESS';
export const DELETE_PLACE_CONTACT_FAILED = 'DELETE_PLACE_CONTACT_FAILED';
